import { render, staticRenderFns } from "./company-jobs-layout.vue?vue&type=template&id=5d4faead"
import script from "./company-jobs-layout.vue?vue&type=script&lang=js"
export * from "./company-jobs-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports